// extracted by mini-css-extract-plugin
module.exports = {"root":"TextureSection_root__v7ko3","title":"TextureSection_title__T0hKh"};